import WalletIcon from "../../components/Icon/WalletIcon";
import UserIcon from "../../components/Icon/UserIcon";
import LocationIcon from "../../components/Icon/LocationIcon";
import Card from "../../components/Icon/Card";
import PastorderIcon from "../../components/Icon/PastorderIcon";
import MyReward from "../../components/Icon/MyReward";
import HamburgerIcon from "../../components/Icon/Hamburger";
import BookmarkIcon from "../../components/Icon/BookMarkIcon";

import {
  WalletPage,
  ProfilePage,
  AddressPage,
  PastOrdersPage,
  RewardsPage,
  PreferencePage,
  BankcardsPage,
  BookmarksPage
} from "../../routes/RoutesPath";

export const profileNavItems = [
  { title: "Profile Info", Icon: UserIcon, to: ProfilePage },
  { title: "Address", Icon: LocationIcon, to: AddressPage },
//   { title: "Bookmarks", Icon: BookmarkIcon, to: BookmarksPage },
  { title: "Bank Cards", Icon: Card, to: BankcardsPage },
  { title: "Past Orders", Icon: PastorderIcon, to: PastOrdersPage },
//   { title: "My Rewards", Icon: MyReward, to: RewardsPage },
  { title: "Preference", Icon: HamburgerIcon, to: PreferencePage },
  { title: "Wallet", Icon: WalletIcon, to: WalletPage },
];
